import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { reduxForm } from 'redux-form';
import { pending } from 'redux-saga-thunk';
import { notification } from 'antd';
import { withRouter } from 'react-router';
import get from 'lodash/get';
import pickBy from 'lodash/pickBy';
import identity from 'lodash/identity';
import {fromEntities, fromResource} from '../../../store/selectors';
import LineItem from '../../../components/pages/LineItem/index';
import {
  resourceDetailReadRequest,
  resourceListReadRequest,
  resourceUpdateRequest
} from '../../../store/resource/actions';
import { createValidator, required, maxLength } from '../../../services/validation/index';

class LineItemContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showCreateInStoreMoment: false,
    };
  }

  componentDidMount() {
    const { getStatuses, getCampaign, getAd } = this.props;
    getStatuses().catch(e =>
      notification.error({
        message: 'Error',
        description: typeof e === 'string' ? e : 'Could not get approval status list.',
        duration: 0,
      })
    );

    getAd()
      .then(() => getCampaign(get(this.props, 'ad.advertiser_campaign_id', false)))
      .catch(e =>
        notification.error({
          message: 'Error',
          description: typeof e === 'string' ? e : 'Could not retrieve campaign or advertisers.',
          duration: 0,
        })
      );
  }

  shouldComponentUpdate(nextProps, nextState, nextContext) {
    if (
      nextProps.ad.advertiser_campaign_id &&
      // No strict comparison because it could be string to int
      // eslint-disable-next-line eqeqeq
      nextProps.urlCampaignId != nextProps.ad.advertiser_campaign_id
    ) {
      window.location.href = `/campaigns/${nextProps.ad.advertiser_campaign_id}/line/${nextProps.ad.id}`;
      return false;
    }

    return true;
  }

  toggleInStoreMoment = () => {
    this.setState({ showCreateInStoreMoment: !this.state.showCreateInStoreMoment });
  };

  render() {
    const { showCreateInStoreMoment } = this.state;
    return (
      <LineItem
        changeActiveKey={this.changeActiveKey}
        toggleInStoreMoment={this.toggleInStoreMoment}
        showCreateInStoreMoment={showCreateInStoreMoment}
        {...this.props}
      />
    );
  }
}

const onSubmit = (values, dispatch, { updateAd }) =>
  updateAd(pickBy(values, identity))
    .then(() => {
      notification.success({ message: 'Success', description: 'Line item saved', duration: 4 });
    })
    .catch(e =>
      notification.error({
        message: 'Error',
        description: typeof e === 'string' ? e : 'Could not save line item.',
        duration: 0,
      })
    );

const mapStateToProps = (
  { modal, ...state },
  {
    match: {
      params: { campaignId, lineItemId },
    },
  }
) => {
  const ad = fromEntities.getDetail(state, 'advertiserAd', lineItemId) || {};
  const campaign =
    fromEntities.getDetail(state, 'advertiserCampaign', ad.advertiser_campaign_id) || {};

  return {
    hasInstore: !!get(
      fromEntities.getDetail(state, 'advertiserAdInstore', lineItemId),
      'creative_service_id',
      false
    ),
    inHandCount: get(state, `resource.advertiserAdInhand.list`, []).length,
    checkinCount: get(state, `resource.advertiserAdCheckinCreative.list`, []).length,
    campaign,
    urlCampaignId: campaignId,
    ad,
    approvalStatuses: fromResource.getList(state, 'advertiserAdApprovalStatus'),
    loading:
      pending(state, 'advertiserAdDetailRead') || pending(state, 'advertiserCampaignDetailRead'),
    initialValues: {
      ...campaign,
      ...ad,
      start_date: ad.start_date === '0000-00-00 00:00:00' ? '' : ad.start_date,
      end_date: ad.end_date === '0000-00-00 00:00:00' ? '' : ad.end_date,
    },
  };
};

const mapDispatchToProps = (
  dispatch,
  {
    match: {
      params: { lineItemId },
    },
  }
) => ({
  getStatuses: () => dispatch(resourceListReadRequest('advertiser-ad/approval-status')),
  getCampaign: campaignId =>
    dispatch(resourceDetailReadRequest('advertiser-campaign/:id', { id: campaignId })),
  getAd: () => dispatch(resourceDetailReadRequest('advertiser-ad/:id', { id: lineItemId })),
  updateAd: data => dispatch(resourceUpdateRequest('advertiser-ad/:id', { id: lineItemId }, data)),
});

const validate = createValidator({
  name: [required, maxLength(80)],
  start_date: [required],
  end_date: [required],
});

export default compose(
  withRouter,
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  reduxForm({
    validate,
    form: 'LineItem',
    onSubmit,
    enableReinitialize: true,
  })
)(LineItemContainer);
